export enum RestockModel {
  DIRECT_SHIP = 'DIRECT_SHIP',
  LOCAL = 'LOCAL'
}
